const tool = {
  toNumberString(num, options) {
    let str = num.toString();
    if (typeof options.figures === 'number') {
      for (let i = str.length; i < options.figures; i++) {
        str = `0${str}`;
      }
    }
    return str;
  },

  standardTimeConversion(val) {
    if (val) {
      const d = new Date(val);
      const dateHours = tool.toNumberString(d.getHours(), {
        figures: 2
      });
      const dateMinutes = tool.toNumberString(d.getMinutes(), {
        figures: 2
      });
      const dateSeconds = tool.toNumberString(d.getSeconds(), {
        figures: 2
      });
      const datetime = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}  ${dateHours}:${dateMinutes}:${dateSeconds}`;
      return datetime;
    }
  },
};
export default tool;